/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CurrencyExchangeConfigurationComponentBase extends models.CurrencyExchangeConfigurationBase {
    getFixupPrototypeFunction() { return CurrencyExchangeConfigurationComponentBase.fixupPrototype; }

    static newInstance(model: Partial<CurrencyExchangeConfigurationComponentBase>): CurrencyExchangeConfigurationComponentBase {
        let obj = Object.assign(new CurrencyExchangeConfigurationComponentBase(), model);
        CurrencyExchangeConfigurationComponentBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CurrencyExchangeConfigurationComponentBase>): CurrencyExchangeConfigurationComponentBase {
        if (!model) return null;
        return CurrencyExchangeConfigurationComponentBase.newInstance(<CurrencyExchangeConfigurationComponentBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CurrencyExchangeConfigurationComponentBase) {
        if (!obj) return;

        models.CurrencyExchangeConfigurationComponentBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CurrencyExchangeConfigurationComponentBase): boolean {
        if (models.CurrencyExchangeConfigurationBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CurrencyExchangeConfigurationComponentBase.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Master account ID
     */
    master_account_id: string;

    tenant_ids: Array<string>;

}
